/* Catnip Guide hub: the sticky section nav filters the article grid in place.
   Every card is in the HTML; this only toggles `hidden`. No fetch. The hash names the view
   (#start-here, #gifts …) and is set with pushState, so the browser doesn't also jump to the
   guide text's H2 of the same name; back/forward replay the filter. A hash that isn't a nav item
   (#safety while Safety has no guides) is left to the browser: it scrolls to that H2 as usual.
   Scroll: the guide text keeps its H2 ids (#gifts …), so the browser's own fragment scrolling would
   land on that H2. This page therefore restores scroll itself (each history entry stores its scrollY;
   a deep link to a filter brings the grid up once the page has loaded). */
(() => {
  const nav = document.querySelector('[data-jg-nav]');
  const grid = document.querySelector('[data-jg-grid]');
  if (!nav) return;
  const root = document.documentElement;
  const links = [...nav.querySelectorAll('[data-jg-filter]')];
  const slugs = links.map((a) => a.dataset.jgFilter);
  const start = document.querySelector('[data-jg-start]');
  const heading = grid && grid.querySelector('[data-jg-heading]');
  const status = grid && grid.querySelector('[data-jg-status]');
  const items = grid ? [...grid.querySelectorAll('[data-jg-section]')] : [];
  const intros = grid ? [...grid.querySelectorAll('[data-jg-intro]')] : [];
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // sticky offsets: the nav sits under the site header; anchors land under both
  const header = document.querySelector('.jc-header-section');
  const measure = () => {
    root.style.setProperty('--jg-header-h', (header ? header.offsetHeight : 0) + 'px');
    root.style.setProperty('--jg-nav-h', nav.offsetHeight + 'px');
  };
  measure();
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(measure);
    if (header) ro.observe(header);
    ro.observe(nav);
  } else {
    window.addEventListener('resize', measure);
  }

  const current = () => {
    const h = decodeURIComponent(location.hash.slice(1));
    return slugs.includes(h) ? h : null;
  };

  const apply = (slug) => {
    const isStart = !slug || slug === 'start-here';
    links.forEach((a) => {
      const on = a.dataset.jgFilter === (isStart ? 'start-here' : slug);
      if (on) {
        a.setAttribute('aria-current', 'true');
        const list = a.closest('.jg-nav__list');
        const left = a.offsetLeft - (list.clientWidth - a.offsetWidth) / 2;
        list.scrollTo({ left, behavior: reduce ? 'auto' : 'smooth' });
      } else {
        a.removeAttribute('aria-current');
      }
    });
    if (start) start.hidden = !isStart;
    if (!grid) return;
    let shown = 0;
    items.forEach((el) => {
      const show = isStart || el.dataset.jgSection === slug;
      el.hidden = !show;
      if (show) shown += 1;
    });
    intros.forEach((p) => { p.hidden = isStart || p.dataset.jgIntro !== slug; });
    const link = links.find((a) => a.dataset.jgFilter === slug);
    const name = !isStart && link ? link.dataset.jgName : heading.dataset.default;
    heading.textContent = name;
    if (status) status.textContent = `${shown} ${shown === 1 ? 'guide' : 'guides'}: ${name}`;
  };

  const reveal = (slug) => {
    const target = !slug || slug === 'start-here' ? (start || grid) : grid;
    if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  };

  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  const remember = () => history.replaceState({ ...(history.state || {}), jgY: window.scrollY }, '');
  let saveTimer;
  window.addEventListener('scroll', () => { clearTimeout(saveTimer); saveTimer = setTimeout(remember, 150); }, { passive: true });

  links.forEach((a) => {
    a.addEventListener('click', (e) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      const slug = a.dataset.jgFilter;
      remember();
      if (current() !== slug) history.pushState({ jg: slug }, '', '#' + slug);
      apply(slug);
      reveal(slug);
    });
  });

  // In-page links to the guide text (the contents list, Start here "Read this section" cards) share their
  // ids with the filter hashes (#safety is both an H2 and a filter). With JS they scroll to the text and
  // leave the address alone, so the hash always names the filter on screen; without JS they're plain anchors.
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a || nav.contains(a) || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const slug = decodeURIComponent(a.getAttribute('href').slice(1));
    const el = slug && document.getElementById(slug);
    if (!el || !slugs.includes(slug)) return;
    e.preventDefault();
    remember();
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  window.addEventListener('popstate', (e) => {
    const slug = current();
    apply(slug);
    const y = e.state && typeof e.state.jgY === 'number' ? e.state.jgY : null;
    requestAnimationFrame(() => {
      if (y !== null) window.scrollTo(0, y);
      else if (slug) reveal(slug);
      else {
        const el = location.hash && document.getElementById(decodeURIComponent(location.hash.slice(1)));
        if (el) el.scrollIntoView(); else window.scrollTo(0, 0);
      }
    });
  });

  const initial = current();
  apply(initial);
  if (initial && initial !== 'start-here') {
    // the browser jumps to the guide text's H2 with this id once the page loads: bring the grid up after it
    const bringUp = () => setTimeout(() => reveal(initial), 0);
    if (document.readyState === 'complete') bringUp(); else window.addEventListener('load', bringUp, { once: true });
  } else if (!location.hash) {
    window.scrollTo(0, 0);
  } else {
    const el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (el) window.addEventListener('load', () => setTimeout(() => el.scrollIntoView(), 0), { once: true });
  }
})();
